<template>
  <div class="wg-row">
    <!-- Filtro a tre colonne -->
    <div 
        id="list-filter-btns"
        class="wg-row project-list-filter-btns wg-md-none">
      <div 
          v-for="(filterBtn, index) in filterBtns"
          :key="'status-bnt-'+index"
          :class="['wg-col', 'wg-xs-4', boardOpen ? 'wg-lg-none' : 'wg-md-none']">
        <div
            :id="'list-filter-btn-'+filterBtn.id" 
            :class="{selected: selectedStatus === filterBtn.id}"
            @click="changeStatus(filterBtn.id)">
          {{ filterBtn.label }}
        </div>
      </div>
    </div>
    <!-- Intestazione 3 colonne - sopra md -->
    <div id="list-cols-labels" :class="['wg-row', 'cols-labels', 'wg-xs-none', boardOpen ? 'wg-lg-' : 'wg-md-']">
      <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
        <div 
            v-for="(filterBtn, index) in filterBtns" 
            :key="index" 
            class="wg-col wg-xs-4 display-flex com-anm22-app-text-l" 
            style="font-weight:bold;justify-content:center;">
          {{ filterBtn.label }}
        </div>
      </div>
    </div>
    <div class="wg-row">
      <div 
          :class="['wg-col', 'wg-xs-12', boardOpen ? 'wg-lg-4' : 'wg-md-4']"
          v-show="selectedStatus === 'waiting' || windowWidth > ( boardOpen ? 1170 : 992)"
          style="padding:0 5px;">
        <task-bar 
            v-for="tdata in waitingTasksData" 
            :key="'waiting-' + tdata.id"
            :taskData="tdata" 
            :view="'cols'"
            @open-task="$emit('open-task', $event)"
        ></task-bar>
      </div>
      <div 
          class="wg-col wg-xs-12 wg-md-4" 
          v-show="selectedStatus === 'running' || windowWidth > 991"
          style="padding:0 5px;">
        <task-bar 
            v-for="(tdata) in runningTasksData" 
            :key="'running-' + tdata.id"
            :taskData="tdata" 
            :view="'cols'"
            @open-task="$emit('open-task', $event)"
        ></task-bar>
      </div>
      <div 
          class="wg-col wg-xs-12 wg-md-4" 
          v-show="selectedStatus === 'completed' || windowWidth > 991"
          style="padding:0 5px;">
        <task-bar 
            v-for="(tdata) in completedTasksData" 
            :key="'completed-'+ tdata.id"
            :taskData="tdata" 
            :view="'cols'"
            @open-task="$emit('open-task', $event)"
        ></task-bar>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TaskBar from '../task/TaskBar.vue';

export default {
  components: {
    TaskBar
  },
  props: {
    tasksData: {
      type: Array,
      required: true
    },
    sortingFunctionGenerator: {
      type: Function,
      required: true
    },
    boardOpen: {
      type: Boolean,
      default: false
    },
    orderingField: {
      type: String,
      default: 'priority'
    },
    orderingDir: {
      type: String,
      default: 'ASC'
    }
  },
  data() {
    return {
      selectedStatus: this.$anm22.getCookie('tk_t_status') !== '' ? this.$anm22.getCookie('tk_t_status') : "running"
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight
    }),
    waitingTasksData() {
      return this.tasksData
        .filter(t => t.status === 1)
        .sort(this.sortingFunctionGenerator(this.orderingField, this.orderingDir));
    },
    runningTasksData() {
      return this.tasksData
        .filter(t => t.status === 2)
        .sort(this.sortingFunctionGenerator(this.orderingField, this.orderingDir));
    },
    completedTasksData() {
      return this.tasksData
          .filter(t => t.status === 3)
          .sort(this.sortingFunctionGenerator(this.orderingField, this.orderingDir));
    },
    filterBtns() {
      return [
        {
          id: "waiting",
          label: this.$anm22.strLang(this.lang, "Waiting", "In attesa")
        },
        {
          id: "running",
          label: this.$anm22.strLang(this.lang, "Running", "In corso")
        },
        {
          id: "completed",
          label: this.$anm22.strLang(this.lang, "Completed", "Completati")
        }
      ];
    }
  },
  methods: {
    changeStatus(status) {
      this.selectedStatus = status;
      this.$anm22.setCookie('tk_t_status', status, 31536000);
    }
  }
}
</script>

<style lang="scss" scoped>
.cols-labels {
  padding: 10px 0;
}
.none {
  display: none;
}
</style>